export default __webpack_public_path__ + "assets/images/c2ad7cccfa276ae56379cc3caa6fcf65.png";